import {PageHeader} from '../index';
import React from 'react';

export default function MyGroupsPageHeader () {
  return (
    <PageHeader title='My Groups Dashboard' height='119px' />
  );
}